var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip-wrapper",on:{"mouseover":function($event){_vm.isVisible = true},"mouseleave":function($event){_vm.isVisible = false}}},[_c('div',{staticClass:"has-tooltip"},[_vm._t("trigger")],2),_vm._v(" "),_c('div',{staticClass:"tooltip",class:{'visible' : _vm.isVisible == true}},[_c('div',{staticClass:"tooltip-text"},[_vm._t("info")],2)])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0130dcf0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/Tooltip.vue
// module id = Wa+b
// module chunks = 0 1